import { authFetch } from "../services/authService";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Archivia una copia immutabile del PDF (fire-and-forget, non blocca l'utente)
export const archivePdf = async (blob, docType, docId, docNumber) => {
  try {
    const formData = new FormData();
    formData.append("file", blob, `${docType}_${docNumber || docId}.pdf`);
    formData.append("doc_type", docType);
    formData.append("doc_id", docId);
    formData.append("doc_number", docNumber || "");
    await authFetch(`${API}/archive/upload`, { method: "POST", body: formData });
  } catch (e) {
    console.error("Archiviazione PDF fallita:", e);
  }
};
